const constants = {
	// baseUrl: "/api",
	baseUrl: "/api",
};

export default constants;
